document.addEventListener("DOMContentLoaded", function () {
  const addGiftBtn = document.getElementById("add-gift-btn");
  const cancelGiftBtn = document.getElementById("cancel-gift-btn");

  const GIFT_VARIANT_ID = 1234567890;

  const GIFT_IMAGE = "https://cdn.shopify.com/s/files/1/your_image_url_here.png";
  const GIFT_TITLE = "🎁 Gift Card";
  const GIFT_PRICE = 1000; 

  addGiftBtn?.addEventListener("click", function () {

    addGiftBtn.textContent = "Gift Added 🎉";
    addGiftBtn.disabled = true;


    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: GIFT_VARIANT_ID,
        quantity: 1,
      })
    })
      .then(res => res.json())
      .then(data => {
        console.log("Gift card added:", data);

        if (window.fetchCart) window.fetchCart();

        // Show cart offcanvas if drawer
        const cartAction = document.getElementById("cart-action")?.textContent.trim();
        if (cartAction === "drawer") {
          const drawer = document.getElementById("cart-offcanvas");
          const offcanvasInstance = bootstrap.Offcanvas.getOrCreateInstance(drawer);
          offcanvasInstance.show();
        }
      })
      .catch(err => console.error("Error adding gift card:", err));
  });

  cancelGiftBtn?.addEventListener("click", function () {
    addGiftBtn.textContent = "Add Gift";
    addGiftBtn.disabled = false;
  });
});
